import { Fragment, useContext } from "react";

import ChatBox from "./components/chat-box/chat-box.component";
import MessageBox from "./components/message-box/message-box.component";
import MessageInput from "./components/message-input/message-input.component";

import { ChatContext } from "src/contexts/chat.context";

import "./chat.style.scss";

const Chat = () => {
	const { chats, selectedChat, setSelectedChat } = useContext(ChatContext);

	const handleChatBoxClick = (matchId) => {
		setSelectedChat(chats[matchId]);
	};

	return (
		<div className="chat-container">
			<div className="left-panel">
				<h1 className="bold with-line">Chat Box</h1>
				{Object.keys(chats).map((matchId, index) => {
					const chat = chats[matchId];
					return (
						<div key={matchId} className="chat-box-button-wrapper">
							<div onClick={() => handleChatBoxClick(matchId)} className="chat-box-button">
								<ChatBox
									chat={chat}
									isSelected={selectedChat?.matchId.toString() === matchId.toString()}
								/>
							</div>
						</div>
					);
				})}
			</div>
			<div className="right-panel">
				{selectedChat && (
					<Fragment>
						<div className="header"></div>
						<div className="messages-wrapper">
							{selectedChat?.messages.reverse().map((messageInstance) => {
								return (
									<MessageBox
										key={JSON.stringify(messageInstance)}
										messageInstance={messageInstance}
									/>
								);
							})}
						</div>
						<div className="message-input-wrapper">
							<MessageInput />
						</div>
					</Fragment>
				)}
			</div>
		</div>
	);
};

export default Chat;
